import { Component, OnInit } from '@angular/core';
import { VehicleService } from '../../../core/services/vehicle.service';
import { Vehicle } from '../../../core/models/vehicle.model';

@Component({
  selector: 'app-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['./vehicle-list.component.css']
})
export class VehicleListComponent implements OnInit {
  vehicles: Vehicle[] = [];
  selectedVehicle: Vehicle | null = null;
  isLoading = false;
  errorMessage = '';

  constructor(private vehicleService: VehicleService) { }

  ngOnInit(): void {
    this.loadVehicles();
  }

  loadVehicles(): void {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.vehicleService.getVehicles().subscribe({
      next: (data) => {
        this.vehicles = data;
        this.isLoading = false;
      },
      error: (error) => {
        this.errorMessage = 'Failed to load vehicles. Please try again.';
        this.isLoading = false;
        console.error('Error loading vehicles:', error);
      }
    });
  }

  loadVehicleDetails(id: number): void {
    this.vehicleService.getVehicleById(id).subscribe({
      next: (vehicle) => {
        this.selectedVehicle = vehicle;
      },
      error: (error) => {
        console.error('Error loading vehicle details:', error);
      }
    });
  }

  createVehicle(): void {
    const newVehicle: Vehicle = {
      vehicleID: 0, // Will be set by the API
      vehicleIdentificationNumber: '1HGCM82633A004352',
      vehicleRegistration: 'CA123456',
      vehicleManufacturerMake: 'Man',
      vehicleManufacturerModel: 'Explora',
      vehicleYear: 2020,
      vehicleSeatingCapacity: 5,
      vehicleGrossVehicleMass: 1800,
      vehicleEngineCapacity: 1600,
      vehicleMaxSpeed: 200,
      vehicleGovernedSpeed: 180,
      vehicleMileage: 35000,
      vehicleLabel: '003',
      vehicleCreateDate: new Date().toISOString(),
      vehicleModifyDate: new Date().toISOString(),
      organisationID: 1,
      organisation: null,
      statusID: 1,
      status: null,
      deviceID: 1001,
      device: null,
      trips: [],
      trackings: null
    };

    // this.vehicleService.createVehicle(newVehicle).subscribe({
    //   next: (createdVehicle) => {
    //     this.vehicles.push(createdVehicle);
    //     console.log('Vehicle created:', createdVehicle);
    //   },
    //   error: (error) => {
    //     console.error('Error creating vehicle:', error);
    //   }
    // });
  }
}